var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"chevron right"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("g",{"id":"chevron_right","data-name":"chevron right"},React.createElement("path",{"d":"M2.5,45a2.49,2.49,0,0,1-1.77-.73,2.52,2.52,0,0,1,0-3.54L19,22.5.73,4.27A2.5,2.5,0,0,1,4.27.73l20,20a2.52,2.52,0,0,1,0,3.54l-20,20A2.49,2.49,0,0,1,2.5,45Z"}))))]);
}

ChevronRight.defaultProps = {"viewBox":"0 0 25 45"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
